module.exports = __webpack_public_path__ + "img/video-img.dc1b8800.png";